module.exports = __webpack_public_path__ + "static/media/header-logo.e248bed6.svg";